














import Vue from 'vue'
import AppMap from '@/components/app/AppMap.vue'

import moment from 'moment'

export default Vue.extend({
  components: { AppMap },
  props: {
    id: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      map: {
        _id: "",
        settings: {
          center: {
            lat: 53,
            lng: -1
          },
          zoom: 6
        },
        title: "Map"
      },
      views: [] as any[]
    }
  },

  computed: {
    markers():MapItem[] {
      const markers:MapItem[] = []
      this.views.forEach(view => {
        if (view.latitude != undefined && view.longitude != undefined) {
          const marker = {
            data: view,
            infoWindowContent: this.infoWindowContent(view),
            position: {
              lat: view.latitude,
              lng: view.longitude
            },
            title: view.name,
            type: "view"
          }
          markers.push(marker)
        }
      })
      return markers
    }
  },

  methods: {
    infoWindowContent(view) {
      return `
        <a style="display: flex; flex-direction: column; align-items: center;" 
          href="${'/views/'+view._id}">
          <p style="padding: 0.5em; font-weight: bold;">${view.name}</p>
          <img 
            src="${view.latestImageURL + '?w=400'}" 
            alt="Latest Available Image for ${view.name}"
            style="width: 100%;"
          />
          <p style="padding: 0.5em;">
            ${moment(view.latestImageDate.toDate()).format("ddd DD MMM YYYY - HH:mm")}
          </p>
        </a>
      `
    },
    initMap() {
      this.$db.collection("maps").doc(this.id).get().then(doc => {
        if (doc.exists) {
          const mapData = doc.data() || this.map
          const settings = {
            center: {
              lat: mapData.latitude || this.map.settings.center.lat,
              lng: mapData.longitude || this.map.settings.center.lng
            },
            zoom: mapData.zoom || this.map.settings.zoom
          }
          const map = {_id: doc.id, settings, title: mapData.name + " Map"}
          this.map = map
        }
      })
    },
    getMapViews() {
      this.$db.collection("maps").doc(this.id).collection("views").get().then(snapshot => {
        const views:any[] = []
        if (snapshot.size) {
          snapshot.forEach(doc => {
            views.push({_id: doc.id, ...doc.data()})
          })
        }
        this.views = views
      })
    },
    markerInfoClick(index) {
      const marker = this.markers[index]
      if (marker.type == "view") {
        //@ts-ignore
        this.$router.push(`/views/${marker.data._id}`)
      }
    }
  },

  created() {
    this.initMap()
    this.getMapViews()
  }
})
